import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from '../AdminFee/styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { Typography, InputLabel, InputAdornment, FormControl, FormHelperText, OutlinedInput, ListItem } from '@mui/material';
export const AccountSetupFee = observer(_ref => {
  let accountSetupFee = _ref.accountSetupFee,
    isLoaded = _ref.isLoaded,
    price = _ref.price;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const feeStructureV2 = store.addNewProperty.feeStructureV2;
  const getStoredAmount = () => {
    var _feeStructureV2$getPr, _feeStructureV2$getPr2;
    return (_feeStructureV2$getPr = (_feeStructureV2$getPr2 = feeStructureV2.getPropertyFee({
      feeName: 'accountSetupFee'
    })) === null || _feeStructureV2$getPr2 === void 0 ? void 0 : _feeStructureV2$getPr2.value) !== null && _feeStructureV2$getPr !== void 0 ? _feeStructureV2$getPr : '';
  };
  const _useState = useState(getStoredAmount),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    overMax = _useState4[0],
    setOverMax = _useState4[1];

  // The fees load after mount, so re-seed from the store once they arrive (as AdminFee does).
  useEffect(() => {
    setAmount(getStoredAmount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountSetupFee, isLoaded]);
  const handleChange = e => {
    const value = e.target.value;
    setOverMax(value !== '' && +value > price);
    if (value === '') {
      setAmount('');
      feeStructureV2.updateFee({
        feeName: 'accountSetupFee',
        value: null
      });
    } else if (+value <= price && /^\d+([.,]\d{0,2})?$/.test(+value)) {
      setAmount(value);
      feeStructureV2.updateFee({
        feeName: 'accountSetupFee',
        value: +value,
        feeUnitType: FEE_UNIT_TYPES.fixedAmount
      });
    }
  };
  if (price === null) return null;
  return /*#__PURE__*/React.createElement(ListItem, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.asf')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.asf_description', {
    price: price.toFixed(2)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    error: overMax,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "account-setup-fee"
  }, t('add_new_property_flow.fee_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "account-setup-fee",
    label: t('add_new_property_flow.fee_value'),
    type: "number",
    value: amount,
    placeholder: price.toFixed(2),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$")
  }), overMax && /*#__PURE__*/React.createElement(FormHelperText, null, t('add_new_property_flow.asf_max', {
    price: price.toFixed(2)
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.caption
  }, t('add_new_property_flow.asf_caption'))));
});